export default __webpack_public_path__ + "static/media/kitchen_basics_topic.901a9e77.jpg";